import React from 'react';
import type { Tone } from '../types/notice';
const toneClass: Record<Tone, string> = {
  success: 'bg-[#E7F4EC] text-[#16834A] ring-[#16834A]/20',
  warning: 'bg-[#FDF3E2] text-[#A86A06] ring-[#E69A20]/30',
  danger: 'bg-[#FCE9EA] text-[#B4232A] ring-[#D93036]/20',
  info: 'bg-[#E8F1FA] text-[#1769AA] ring-[#1769AA]/20',
  neutral: 'bg-slate-100 text-slate-600 ring-slate-300/50',
  navy: 'bg-[#003B71] text-white ring-[#003B71]'
};
const autoTone: Record<string, Tone> = {
  সম্পন্ন: 'success',
  অনুমোদিত: 'success',
  যাচাইকৃত: 'success',
  তৈরি: 'success',
  প্রেরিত: 'success',
  প্রিন্টকৃত: 'info',
  নিষ্পত্তিকৃত: 'success',
  সক্রিয়: 'success',
  সফল: 'success',
  'পর্যালোচনা প্রয়োজন': 'warning',
  পর্যালোচনাধীন: 'warning',
  'অনুমোদন অপেক্ষমাণ': 'warning',
  'যাচাই অপেক্ষমাণ': 'warning',
  'সংশোধনে ফেরত': 'warning',
  'ব্যবস্থা গ্রহণ': 'info',
  প্রক্রিয়াধীন: 'info',
  অপেক্ষমাণ: 'neutral',
  'প্রিন্ট অপেক্ষমাণ': 'neutral',
  নতুন: 'info',
  প্রতিস্থাপিত: 'neutral',
  'নতুন সংস্করণ দ্বারা প্রতিস্থাপিত': 'neutral',
  নিষ্ক্রিয়: 'neutral',
  প্রত্যাখ্যাত: 'danger',
  বাতিল: 'danger',
  অবৈধ: 'danger',
  ব্যর্থ: 'danger',
  'ফেরত এসেছে': 'danger'
};
interface StatusBadgeProps {
  label: string;
  tone?: Tone;
  className?: string;
}
export function StatusBadge({
  label,
  tone,
  className = ''
}: StatusBadgeProps) {
  const t = tone ?? autoTone[label] ?? 'neutral';
  return <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${toneClass[t]} ${className}`} data-id="element-643" data-mp="1rgky4gn8dll2">
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" aria-hidden data-id="element-644" data-mp="1hqhyhxllt9dr" />
      {label}
    </span>;
}